import type { FC } from "react";
import { useState } from "react";
import type { IProModal } from "pro-features/components/Modals/src/ProModal";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import { DeleteAssetConfirm } from "app/components/modals/components/DeleteAssetConfirm";
import type { ICustomSegments } from "app/services/segments/segmentsApiService";

interface IDeleteSegmentsModal {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    onDelete: VoidFunction;
    selectedSegments: ICustomSegments;
}

export const DeleteSegmentsModal: FC<IDeleteSegmentsModal> = ({
    isOpen,
    setIsOpen,
    onDelete: onDeleteCallback,
    selectedSegments = [],
}) => {
    const onDelete = () => {
        setIsLoading(true);
        onDeleteCallback();
    };
    const [isLoading, setIsLoading] = useState(false);
    const onClose = () => setIsOpen(false);
    const proModalProps: IProModal = {
        showCloseIcon: false,
        customStyles: { content: { padding: 0, width: "auto" } },
        onCloseClick: onClose,
        isOpen,
    };
    const count = selectedSegments.length;
    const isPlural = count !== 1;
    const titleKey = isPlural ? "custom.segments.confirm.delete.title" : "custom.segment.confirm.delete.title";
    const contentKey = isPlural ? "custom.segments.confirm.delete.content" : "custom.segment.confirm.delete.content";
    return (
        <ProModal {...proModalProps}>
            <DeleteAssetConfirm
                title={translate(titleKey)}
                content={translate(contentKey, { count })}
                onClose={onClose}
                isLoading={isLoading}
                onDelete={onDelete}
            />
        </ProModal>
    );
};
